/** Loom walkthroughs are attached to a 3D model *release*, not the portal project. */

export function loomUrlForRelease(release?: { loomUrl?: string } | null): string {
  return (release?.loomUrl || '').trim();
}

/**
 * Client-facing walkthrough for the current 3D model version.
 * A new release with no loomUrl must not inherit a previous video.
 */
export function clientFacingModelLoomUrl(
  currentModelRelease?: { loomUrl?: string } | null,
): string | undefined {
  const url = loomUrlForRelease(currentModelRelease);
  return url || undefined;
}

export type ModelLoomHistoryEntry = {
  releaseId: string;
  releaseVersionIndex: number;
  loomUrl: string;
  releasedAt?: Date;
};

/** Newest-first history of Looms that were actually attached to a model version. */
export function modelLoomHistory(
  releases: Array<{
    id?: string;
    releaseVersionIndex?: number;
    loomUrl?: string;
    releasedAt?: Date;
  }>,
): ModelLoomHistoryEntry[] {
  return releases
    .filter(r => !!r.id && !!loomUrlForRelease(r))
    .sort((a, b) => (b.releaseVersionIndex ?? 0) - (a.releaseVersionIndex ?? 0))
    .map(r => ({
      releaseId: r.id as string,
      releaseVersionIndex: r.releaseVersionIndex ?? 0,
      loomUrl: loomUrlForRelease(r),
      releasedAt: r.releasedAt,
    }));
}
